module.exports = __webpack_public_path__ + "img/1.3a3164c1.svg";